import { render, staticRenderFns } from "./buy_vipResultDialog.vue?vue&type=template&id=dcff3428&"
import script from "./buy_vipResultDialog.vue?vue&type=script&lang=js&"
export * from "./buy_vipResultDialog.vue?vue&type=script&lang=js&"
import style0 from "./buy_vipResultDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports